<template>
  <div>
    <div :class="`switchbox__item ${boxClass}`">
      <span class="switchbox__label">
        {{ label }}
        <span v-if="infoTooltip" v-b-tooltip.hover :title="infoTooltip">
          <mdicon name="help-circle-outline" size="16" />
        </span>
      </span>
      <span v-if="loading" class="flex">
        <mdicon name="loading" size="20" class="spinner" />
      </span>
      <span v-show="!loading" class="switchbox__input-box">
        <span v-if="showStateText">
          <small v-if="!!checkboxValue" class="switchbox__state-text">
            {{ checkedStateText }}
          </small>
          <small v-else class="switchbox__state-text">
            {{ uncheckedStateText }}
          </small>
        </span>
        <b-form-checkbox
          class="cursor--pointer"
          v-model="checkboxValue"
          :switch="true"
          :size="size"
          :value="checkedValue"
          :unchecked-value="uncheckedValue"
          :disabled="disabled"
          @change="handleChange"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { computed, toRefs } from "vue";
export default {
  props: {
    value: {}, // watch model
    label: {
      type: String,
      default: "",
    },
    infoTooltip: {
      type: String,
      default: "",
    },
    name: {
      type: [String, Number],
      default: "",
    },
    checkedValue: {
      type: [Boolean, Number],
      default: true,
    },
    uncheckedValue: {
      type: [Boolean, Number],
      default: false,
    },
    size: {
      type: String,
      default: "lg",
    },
    hoverClass: {
      type: String,
      default: "switchbox__item--hover",
    },
    boxClass: {
      type: String,
      default: "padding-x-8 margin-bottom-8",
    },
    showStateText: {
      type: Boolean,
      default: false,
    },
    checkedStateText: {
      type: String,
      default: "فعال",
    },
    uncheckedStateText: {
      type: String,
      default: "غیرفعال",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const {
      value,
      label,
      infoTooltip,
      name,
      checkedValue,
      uncheckedValue,
      size,
      boxClass,
      showStateText,
      checkedStateText,
      uncheckedStateText,
      loading,
    } = toRefs(props);

    // watching input value
    const checkboxValue = computed({
      get() {
        return value.value;
      },
      set(val) {
        emit("input", name.value, val);
      },
    });

    // handle change event
    const handleChange = () => emit("handleChange");

    // return data to be used in template
    return {
      value,
      label,
      infoTooltip,
      name,
      checkedValue,
      uncheckedValue,
      size,
      boxClass,
      showStateText,
      checkedStateText,
      uncheckedStateText,
      loading,
      checkboxValue,
      handleChange,
    };
  },
};
</script>
